/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { PaginatedDocumentPublic } from './PaginatedDocumentPublic'
import {
  PaginatedDocumentPublicFromJSON,
  PaginatedDocumentPublicFromJSONTyped,
  PaginatedDocumentPublicToJSON,
} from './PaginatedDocumentPublic'

/**
 *
 * @export
 * @interface EnvelopedDocumentListDocumentPublic
 */
export interface EnvelopedDocumentListDocumentPublic {
  /**
   *
   * @type {PaginatedDocumentPublic}
   * @memberof EnvelopedDocumentListDocumentPublic
   */
  body: PaginatedDocumentPublic
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedDocumentListDocumentPublic
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedDocumentListDocumentPublic interface.
 */
export function instanceOfEnvelopedDocumentListDocumentPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedDocumentListDocumentPublicFromJSON(
  json: any,
): EnvelopedDocumentListDocumentPublic {
  return EnvelopedDocumentListDocumentPublicFromJSONTyped(json, false)
}

export function EnvelopedDocumentListDocumentPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedDocumentListDocumentPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: PaginatedDocumentPublicFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedDocumentListDocumentPublicToJSON(
  value?: EnvelopedDocumentListDocumentPublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: PaginatedDocumentPublicToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
